{
  "list": {
    "title": "القوالب",
    "add": "إضافة قالب",
    "filters": {
      "status": "الحالة",
      "language": "اللغة"
    },
    "columns": {
      "key": "مفتاح القالب",
      "language": "اللغة",
      "metaName": "اسم القالب في Meta",
      "variables": "المتغيرات",
      "description": "الوصف",
      "status": "الحالة"
    },
    "rowActions": {
      "trigger": "إجراءات {{name}}"
    }
  },
  "drawer": {
    "createTitle": "إضافة قالب",
    "editTitle": "تعديل القالب",
    "createDescription": "تسجيل قالب معتمد في Meta ليستخدمه سجل الرسائل.",
    "editDescription": "تحديث بيانات هذا القالب في Meta ووصفه.",
    "fields": {
      "key": "مفتاح القالب",
      "language": "اللغة",
      "metaName": "اسم القالب في Meta",
      "metaLanguage": "رمز اللغة في Meta",
      "variables": "المتغيرات",
      "variablesHelp": "يحدد هذا الترتيب متغيرات القالب المعتمد بالتسلسل من الأول للأخير.",
      "addVariable": "إضافة متغير",
      "variablePlaceholder": "اسم المتغير",
      "moveUp": "تحريك لأعلى",
      "moveDown": "تحريك لأسفل",
      "removeVariable": "حذف المتغير",
      "bodyText": "نص الرسالة",
      "headerType": "رأس الرسالة",
      "headerTypeHelp": "اختر «صورة» إذا كان رأس القالب في Meta صورة، مثل رمز QR.",
      "headerTypeNone": "بدون",
      "headerTypeImage": "صورة",
      "descriptionAr": "الوصف بالعربية",
      "descriptionEn": "الوصف بالإنجليزية",
      "verificationCode": "قالب رمز تحقق",
      "verificationCodeHelp": "قالب مصادقة من Meta، متغيره الوحيد code ولا يتغير بعد الإنشاء."
    },
    "created": "تم إنشاء القالب بنجاح",
    "updated": "تم تحديث القالب بنجاح"
  },
  "statusConfirmTitle": "تغيير حالة هذا القالب؟",
  "statusConfirmDescription": "سيصبح \"{{name}}\" {{status}}.",
  "statusChanged": "تم تغيير حالة القالب بنجاح"
}
